import Swiper, { Navigation } from 'swiper';
export default function initHeaderHome() {
    const $headerHome = document.querySelector<HTMLElement>('.header-home');

    if ($headerHome) {
        new HeaderHome($headerHome);
    }
}

export class HeaderHome {
    $container: HTMLElement;
    $cards: NodeListOf<HTMLElement> | null;
    $slider: HTMLElement | null | undefined;
    swiper: Swiper | null = null;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$slider = this.$container?.querySelector('.topic-wrapper');
        window.addEventListener('resize', this.onWindowResize.bind(this));
        this.onWindowResize();
    }

    /**
     * Événement lancé à chaque resize de la fenêtre
     * Détermine s'il faut créer ou détruire le swiper
     */
    onWindowResize(): void {

        if (this.$slider) {


            if (!this.swiper) {
                // Créé le swiper s'il n'est pas déjà créé et que la taille liste des boutons n'est pas supérieure a celle de son container
                this.createSwiper();
            }
            else {
                // Détruit le swiper s'il est déjà créé et que la liste des boutons n'est pas supérieure a celle de son container
                this.destroySwiper();
            }
        }
    }

    /**
     * gere l'effet de tilt des cartes
     * 
     * @param {HTMLElement} $card
     *
     * @return {void}
     */
    init($card: HTMLElement) {
        $card.addEventListener('mousemove', (event: MouseEvent) => {
            if ($card) {
                const cardWidth = $card.clientWidth;
                const cardHeight = $card.clientHeight;
                const cardBound = $card.getBoundingClientRect();
                const centerX = cardBound.left + cardWidth/2;
                const centerY = cardBound.top + cardHeight/2;

                const mouseX = event.clientX - centerX;
                const mouseY = event.clientY - centerY;

                const rotateX = 18*mouseY/(cardHeight/2);
                const rotateY = 18*mouseX/(cardWidth/2);

                $card.style.transform = `perspective(1000px) translateZ(40px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

            }
        });

        $card.addEventListener('mouseleave', ()=>{
            if ($card) {
                $card.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg)`
            }

        })
    }

    /**
     * Créé le swiper
     */
    createSwiper(): void {
        if (this.$slider) {

            this.$slider.querySelector('.slider-next')?.classList.add('slider-next--active');
            this.$slider.querySelector('.slider-prev')?.classList.add('slider-prev--active');

            new Swiper(this.$slider, {
                modules: [Navigation],
                slidesPerView: 'auto',
                spaceBetween: 20,
                loop: false,
                allowTouchMove: true,
                grabCursor: true,
                navigation: {
                    nextEl: '.slider-next',
                    prevEl: '.slider-prev',
                },
            });
        }
    }

    /**
     * Détruit le swiper
     */
    destroySwiper(): void {

        if (this.$slider) {
            this.$slider.querySelector('.slider-next')?.classList.remove('slider-next--active');
            this.$slider.querySelector('.slider-prev')?.classList.remove('slider-prev--active');
        }

        this.swiper?.destroy(true, true);
        this.swiper = null;
    }
}
